import { render } from "./activityInfo.vue?vue&type=template&id=04e23769&scoped=true"
import script from "./activityInfo.vue?vue&type=script&lang=js"
export * from "./activityInfo.vue?vue&type=script&lang=js"

import "./activityInfo.vue?vue&type=style&index=0&id=04e23769&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e23769"]])

export default __exports__